var map = {
	"./asset-hyperlink.json": 7797,
	"./blockquote.json": 8200,
	"./document.json": 2396,
	"./embedded-asset-block.json": 8745,
	"./embedded-entry-block.json": 2482,
	"./embedded-entry-inline.json": 8569,
	"./entry-hyperlink.json": 1950,
	"./heading-1.json": 4195,
	"./heading-2.json": 2686,
	"./heading-3.json": 9226,
	"./heading-4.json": 6449,
	"./heading-5.json": 2279,
	"./heading-6.json": 37,
	"./hr.json": 7364,
	"./hyperlink.json": 8750,
	"./list-item.json": 326,
	"./ordered-list.json": 1457,
	"./paragraph.json": 6043,
	"./table-cell.json": 1073,
	"./table-header-cell.json": 7497,
	"./table-row.json": 1279,
	"./table.json": 2440,
	"./text.json": 7750,
	"./unordered-list.json": 8582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9173;